'use client';

import { Link } from '@packages/modules/src/Link/Link';
import type { GenericTrackingEvent } from '@packages/tracking/src/types/events';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { defineMessage, useIntl } from 'react-intl';

const logoTitle = defineMessage({
  id: 'logo.title',
  defaultMessage: 'zur Startseite',
});
/** Header tenant logo. Links to home */
export const LinkedLogo = () => {
  const { formatMessage } = useIntl();
  const dispatchGtmEvent = useTracking();

  const trackLogoClick = () => {
    dispatchGtmEvent<GenericTrackingEvent>({
      event: 'suche-event',
      eventValue: 'homepage=storefront',
    });
  };
  return (
    <Link
      aria-label={formatMessage(logoTitle)}
      href="/"
      title={formatMessage(logoTitle)}
      onClick={trackLogoClick}
      className="flex h-full items-center py-0.5"
    >
      <div
        aria-hidden
        className="tenant-logo icon-emp-logo relative h-full bg-contain bg-left align-middle"
      />
    </Link>
  );
};
